import { FormattedMessage } from "react-intl";

import SBEditable from "../../../components/sbEditable/sbEditable";
import ListingHeader from "../../../components/listingHeader/listingHeader";
import RefCardsCarousel from "../../../components/refCardsCarousel/refCardsCarousel";
import AnimeSeriesCard from "../../../components/animeSeriesCard/animeSeriesCard";

import { useStoryblokGlobalSettings } from "../../../hooks/useStoryblokGlobalSettings";
import useMediaQuery from "../../../hooks/useMediaQuery";

import styles from "./seriesListingWidget.module.scss";
import { useStoryblokSeriesWidget } from "../../../hooks/useStoryblokSeriesWidget";
import StreamCard from "../../../components/streamCard/streamCard";
import { useOutletContext } from "react-router-dom";
import { useCompressedImage } from "../../../components/storyblokImageBasic/helpers";

/// >> Blok:serieslisting
// headline:text
function SeriesListingWidget({ blok }) {
  const { story } = useOutletContext();
  const [streams, isLoading] = useStoryblokSeriesWidget();
  const globalSettings = useStoryblokGlobalSettings();
  const isMobile = useMediaQuery("(max-width: 992px)");

  const { content: { crcms_guid } } = story;

  if (crcms_guid) {
    return null;
  }

  if (!isLoading && streams.length === 0) {
    return null;
  }

  const backgroundImageURI = useCompressedImage(globalSettings?.carousel_background_image?.filename)

  return (
    <SBEditable blok={blok} withClass={styles.seriesListingWidget}>
      <div
        className={styles.carousel}
        style={
          isMobile
            ? {
                backgroundImage: `url(${backgroundImageURI}), linear-gradient(305.82deg, #213944 11.54%, #2ABDBB 95.62%)`,
              }
            : null
        }
      >
        {isMobile ? (
          <div className={styles.header}>
            <h3>
              <FormattedMessage id="component.series_listing_widget.headline" />
            </h3>
          </div>
        ) : (
          <ListingHeader>
            <h3>
              <FormattedMessage id="component.series_listing_widget.headline" />
            </h3>
          </ListingHeader>
        )}
        {isLoading ? <div className="loader centered" /> : null}
        {isMobile ? (
          // MOBILE CAROUSEL
          <div className={styles.mobilecarousel}>
            {streams && streams.length ? (
              <RefCardsCarousel
                desktopOptions={{ perPage: 3 }}
                tabletOptions={{ perPage: 3 }}
                smallTabletOptions={{ perPage: 3 }}
                mobileExtendedOptions={{ perPage: 3, gap: 10 }}
                mobileOptions={{ perPage: 2, gap: 10 }}
                extraSmallOptions={{ perPage: 1, gap: 10 }}
              >
                {streams.map((stream) => (
                  <AnimeSeriesCard series={stream} />
                ))}
              </RefCardsCarousel>
            ) : null}
          </div>
        ) : (
          // DESKTOP LAYOUT
          <ul className={styles.wrapper}>
            {streams.map((stream) => (
              <li key={stream.uuid}>
                <StreamCard
                  image={stream.crcms_wide_poster?.filename}
                  alt={stream.crcms_wide_poster?.imageAlt}
                  imageTitle={stream.crcms_wide_poster?.imageTitle}
                  title={stream.crcms_title}
                  buttonLink={stream.series_url || ""}
                />
              </li>
            ))}
          </ul>
        )}
      </div>
    </SBEditable>
  );
}

export default SeriesListingWidget;
